import React, { useState } from 'react';
import classNames from 'classnames';
import { Collapse, Spacer } from '@cleartrip/bento';

function Expanded({ active, toggleActive, children, className, collapsedLabel, expandedLabel }) {
	const labelClass = classNames(
		'c-secondary-500',
		'fs-4',
		'fw-500',
		'c-pointer',
		'hover:c-secondary-400',
		'hover:td-underline',
		'py-2 flex-inline',
		className
	);

	return (
		<>
			<Collapse pose={active ? 'open' : 'collapsed'}>{children}</Collapse>
			<div onClick={() => toggleActive(!active)}>
				{!active ? <div className={labelClass}>{collapsedLabel}</div> : <div className={labelClass}>{expandedLabel}</div>}
			</div>
		</>
	);
}

Expanded.defaultProps = {
	className: null,
	active: false,
	collapsedLabel: 'View details',
	expandedLabel: 'Hide details',
};

export default Expanded;
